import React, { useRef } from 'react';
import { Box, Button, ButtonGroup, Menu, MenuItem } from '@mui/material';
import { FileUpload, Download } from '@mui/icons-material';

export interface ImportExportBarProps {
  onImportCSV?: (csvText: string) => void;
  onImportJSON?: (jsonText: string) => void;
  getExportCSV?: () => { filename: string; content: string };
  getExportJSON?: () => { filename: string; content: string };
}

const ImportExportBar: React.FC<ImportExportBarProps> = ({ onImportCSV, onImportJSON, getExportCSV, getExportJSON }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleChooseFile = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const text = await file.text();
    const name = file.name.toLowerCase();
    if (name.endsWith('.csv') && onImportCSV) onImportCSV(text);
    else if (name.endsWith('.json') && onImportJSON) onImportJSON(text);
    e.target.value = '';
  };

  const triggerDownload = (filename: string, content: string) => {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const handleExportCSV = () => {
    if (!getExportCSV) return;
    const { filename, content } = getExportCSV();
    triggerDownload(filename, content);
  };

  const handleExportJSON = () => {
    if (!getExportJSON) return;
    const { filename, content } = getExportJSON();
    triggerDownload(filename, content);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <input ref={fileInputRef} type="file" accept=".csv,.json" onChange={handleFileChange} hidden />
      <Button variant="outlined" startIcon={<FileUpload />} onClick={handleChooseFile}>
        Importer (CSV/JSON)
      </Button>
      <ButtonGroup variant="outlined">
        <Button startIcon={<Download />} onClick={handleExportCSV} disabled={!getExportCSV}>Exporter CSV</Button>
        <Button startIcon={<Download />} onClick={handleExportJSON} disabled={!getExportJSON}>Exporter JSON</Button>
      </ButtonGroup>
    </Box>
  );
};

export default ImportExportBar;